import { render } from "./actionDatabaseComponent.vue?vue&type=template&id=e7f7cc80"
import script from "./actionDatabaseComponent.vue?vue&type=script&lang=js"
export * from "./actionDatabaseComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__